import { useObserva } from "@morganisbatman/observa-client-react";
import { useEffect, useRef } from "react";

// Fires voice.session_started on mount and voice.session_ended on
// unmount with elapsed durationMs. Captured via a ref so React strict-
// mode double-invokes don't reset the start time mid-session.
export function useVoiceSessionEvents(verticalSlug: string | null): void {
  const observa = useObserva();
  const sessionStartedAtRef = useRef<number>(Date.now());

  useEffect(() => {
    sessionStartedAtRef.current = Date.now();
    void observa.event({
      eventType: "voice.session_started",
      payload: { verticalSlug },
    });
    return () => {
      void observa.event({
        eventType: "voice.session_ended",
        payload: {
          verticalSlug,
          durationMs: Math.max(0, Date.now() - sessionStartedAtRef.current),
        },
      });
    };
    // Intentionally only fire on mount/unmount — vertical changes
    // during a live voice session are not a use case today.
  }, []);
}
